/**
 * Email Arche Local Types
 *
 * Supplementary types beyond what api.ts exports.
 */

export type FolderSystemRole = 'inbox' | 'sent' | 'drafts' | 'trash' | 'spam' | 'archive';

export type SmartCategory = 'primary' | 'feed' | 'paper_trail' | 'notifications';

/**
 * React Query exposes mutation/query errors as `unknown`. Casting straight to
 * `Error` is unsafe — a non-Error rejected promise (string, plain object)
 * silently turns `.message` into `undefined`, so the surfaced UI error becomes
 * the literal string "undefined". Use this guard at every hook seam where we
 * unwrap a TanStack Query error into a user-facing string.
 */
export function errorMessage(err: unknown): string | null {
  if (err == null) return null;
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  return String(err);
}
